import { createContext, useContext } from 'react';

import type { MeDTO } from '@/features/auths/schemas/get-me.schema';
import type { SigninPayload } from '@/features/auths/schemas/sign-in.schema';

export interface AuthContext {
  user: MeDTO | null;
  isLoadingAuth: boolean;
  isAuthenticated: boolean;
  isSigningIn: boolean;
  isSigningOut: boolean;
  isFetchUser: boolean;
  isAdminRole: boolean;
  isSuperadminRole: boolean;
  isEditorRole: boolean;
  signIn: (params: SigninPayload) => Promise<void>;
  signOut: () => Promise<void>;
  refetchUser: () => Promise<unknown>;
}

export const authContext = createContext<AuthContext | null>(null);

export function useAuthContext(): AuthContext {
  const ctx = useContext(authContext);
  if (ctx == null) {
    throw new Error('useAuthContext must be used within <AuthProvider>.');
  }
  return ctx;
}
